module.exports = __webpack_public_path__ + "static/media/rundruf.894779d2.svg";